{
    "warning": "മുന്നറിയിപ്പ്!",
    "message": "നിങ്ങൾക്ക് മനസ്സിലാകാത്ത കോഡ് നൽകുകയോ ഒട്ടിക്കുകയോ ചെയ്യരുത്.\nഈ കൺസോൾ ഉപയോഗിക്കുന്നതിലൂടെ, Self-XSS എന്ന് അറിയപ്പെടുന്ന ആക്രമണം വഴി അറ്റാക്കർമാർക്ക് നിങ്ങളുടെ വിവരങ്ങൾ മോഷ്ടിക്കാനും നിങ്ങളായി ആൾമാറാട്ടം നടത്താനും കഴിയും."
}
